/**
 * Активный учебный экземпляр вкладки: после перезагрузки остаётся только его ID, manifest
 * загружается заново (обязательный bootstrap). Ключ привязан к компании и пользователю:
 * другой пользователь той же вкладки чужой экземпляр не подхватит. Хранилище браузера
 * может быть недоступно -- тогда режим живёт только в адресе страницы.
 */

const PREFIX = 'qh.training.active';

function key(identity: string): string {
	return `${PREFIX}:${identity}`;
}

export function readActiveInstance(identity: string | null): string | null {
	if (identity === null) return null;
	try {
		return window.sessionStorage.getItem(key(identity));
	} catch {
		return null;
	}
}

export function writeActiveInstance(identity: string | null, instanceId: string): void {
	if (identity === null) return;
	try {
		window.sessionStorage.setItem(key(identity), instanceId);
	} catch {
		/* Без хранилища режим держится параметром адреса */
	}
}

export function clearActiveInstance(identity: string | null): void {
	if (identity === null) return;
	try {
		window.sessionStorage.removeItem(key(identity));
	} catch {
		/* Нечего очищать */
	}
}
